import React, { useState, useEffect } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { 
    Box, 
    AppBar, 
    Toolbar, 
    Typography, 
    Button,
    IconButton,
    Tooltip,
    CircularProgress,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { DeviceTable } from './DeviceTable';
import { DeviceSummaryTable } from './DeviceSummaryTable';
import { useThemeContext } from '../theme/ThemeContext';
import { getInstance } from '../auth/msalInstance';
import { config } from '../config';
import type { PublicClientApplication } from "@azure/msal-browser";

export const Layout: React.FC = () => {
    const { mode, toggleTheme } = useThemeContext();
    const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);

    useEffect(() => {
        getInstance().then(instance => {
            setMsalInstance(instance);
        });
    }, []);

    const handleLogout = async () => {
        if (!msalInstance) return;
        
        try {
            await msalInstance.logoutPopup();
        } catch (e) {
            console.error('Logout error:', e);
        }
    };

    if (!msalInstance) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 0 }}>
                        {config.TITLE}
                    </Typography>
                    <Box sx={{ flexGrow: 1, ml: 2 }}>
                        <Button color="inherit" component={Link} to="/">
                            Devices
                        </Button>
                        <Button color="inherit" component={Link} to="/summary">
                            Device Summary
                        </Button>
                    </Box>
                    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
                        <IconButton sx={{ ml: 1 }} onClick={toggleTheme} color="inherit">
                            {mode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
                        </IconButton>
                    </Tooltip>
                    <Button 
                        color="inherit"
                        onClick={handleLogout}
                        startIcon={<LogoutIcon />}
                    >
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Routes>
                    <Route path="/" element={<DeviceTable />} />
                    <Route path="/summary" element={<DeviceSummaryTable />} />
                </Routes>
            </Box>
        </Box>
    );
}; 